// extracted by mini-css-extract-plugin
export var AuthorSnippet = "style-module--AuthorSnippet--7c737";
export var Avatar = "style-module--Avatar--1e2ce";
export var Bio = "style-module--Bio--2fd8d";
export var Description = "style-module--Description--1bbd7";
export var WrittenBy = "style-module--WrittenBy--181a0";